import React, { useEffect, useState } from 'react';
import { auditApi } from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Loader2, ClipboardList, Download } from 'lucide-react';

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { auditApi.list({ limit: 500 }).then(r => setLogs(r.data)).finally(() => setLoading(false)); }, []);

  const exportCsv = async () => {
    const r = await auditApi.export();
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement('a'); a.href = url; a.download = 'aea_audit.csv'; a.click();
  };

  return (
    <div className="animate-fade-in-up">
      <Card className="aea-card">
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2"><ClipboardList className="w-5 h-5 text-aea-blue" /> Auditoría y trazabilidad</CardTitle>
            <p className="text-sm text-slate-500 mt-1">Registro inmutable de todas las acciones del espacio de datos.</p>
          </div>
          <Button variant="outline" onClick={exportCsv} data-testid="btn-export-audit"><Download className="w-4 h-4 mr-2" /> Exportar CSV</Button>
        </CardHeader>
        <CardContent className="p-0">
          {loading ? <div className="flex justify-center py-10"><Loader2 className="animate-spin text-aea-blue" /></div> :
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="text-left p-3">Fecha</th>
                    <th className="text-left p-3">Usuario</th>
                    <th className="text-left p-3">Acción</th>
                    <th className="text-left p-3">Recurso</th>
                    <th className="text-left p-3">Detalles</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-slate-500">Sin registros</td></tr>}
                  {logs.map(l => (
                    <tr key={l.id} className="border-t" data-testid={`audit-row-${l.id}`}>
                      <td className="p-3 font-mono text-xs">{new Date(l.timestamp).toLocaleString('es-ES')}</td>
                      <td className="p-3 text-xs">{l.user_email}</td>
                      <td className="p-3"><code className="text-xs bg-slate-100 px-2 py-0.5 rounded">{l.action}</code></td>
                      <td className="p-3 text-xs text-slate-500">{l.resource_type}</td>
                      <td className="p-3 text-xs font-mono text-slate-500 max-w-xs truncate">{JSON.stringify(l.details)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          }
        </CardContent>
      </Card>
    </div>
  );
}
